<template>
    <div class="min-h-screen bg-gray-50">
        <div class="container mx-auto px-4 py-8 max-w-7xl">
            <!-- Header with Welcome and Date -->
            <div class="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                <div>
                    <h1 class="text-3xl font-bold text-gray-900 flex items-center">
                        Welcome back, {{ currentUser.name }}
                        <span class="ml-3 text-sm font-normal text-gray-500 bg-white px-3 py-1 rounded-full shadow-sm">
                            {{ currentDate }}
                        </span>
                    </h1>
                    <p class="text-lg text-gray-600 mt-1">
                        Update Mpesa statement
                    </p>
                </div>
            </div>


            <!-- Bottom Grid -->
            <div class="grid grid-cols-1 lg:grid-cols-1 gap-8">
                <!-- Recent Tickets -->
                <div class="lg:col-span-2 bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                    <div class="flex items-center justify-between mb-6">
                        <h3 class="text-lg font-semibold text-gray-900">Mpesa Statement Upload Form</h3>
                    </div>

                    <div class="space-y-4">

                        <form @submit.prevent="submit" class="space-y-6">
                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-1">Mpesa Statement</label>
                                <input @change="handleFileUpload" type="file" required accept=".pdf"
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 outline-none transition">
                                <!--<p v-if="uploadForm.errors.mpesa_statement" class="text-red-500 text-sm mt-1">{{
                                    uploadForm.errors.mpesa_statement }}</p>-->
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-1">Mpesa Password</label>
                                <input v-model="uploadForm.mpesa_password" type="password" required
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 outline-none transition">

                            </div>

                            <div class="pt-2 flex justify-end">
                                <button type="submit" :disabled="uploadForm.processing"
                                    class="bg-green-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-md transition duration-200 shadow-sm disabled:opacity-50">
                                    {{ uploadForm.processing ? 'Saving...' : 'Submit Statement' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>

        </div>

        <!-- Floating Action Button -->
        <button @click="getDashboardData"
            class="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-800 text-white shadow-lg transition-all duration-300 hover:bg-indigo-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            aria-label="Refresh page">
            <!-- Refresh icon (SVG) -->
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" :class="{ 'animate-spin': isRefreshing }">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
        </button>

        <div v-if="isRefreshing"
            class="fixed inset-0 ml-64 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50">
            <div class="relative">
                <!-- Outer ring -->
                <div class="w-16 h-16 border-4 border-gray-200 rounded-full"></div>
                <!-- Inner spinning gradient ring -->
                <div
                    class="w-16 h-16 border-4 border-transparent rounded-full absolute top-0 left-0 border-t-indigo-500 border-r-indigo-700 animate-spin">
                </div>
                <!-- Center dot -->
                <div
                    class="w-3 h-3 bg-indigo-800 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, reactive } from "vue";
    // import { useRouter } from "vue-router";
    //import StatusBadge from "@/components/ui/StatusBadge.vue";
    import { useAuthStore } from "@/stores/authStore";
    //import api from "@/utils/api";

    // const form = useForm({
    //     mpesa_statement: '',
    //     mpesa_code: ''
    // });

    const uploadForm = reactive({
        mpesa_statement: null,
        mpesa_code: '',
    });

    const handleFileUpload = (event) => {
        uploadForm.mpesa_statement = event.target.files[0] || null;
    };

    function submit() {
        // Form submission logic requires handling FormData for file uploads
        console.log("Submit file:", uploadForm.mpesa_statement);
        if (typeof uploadForm.post === 'function') {
            uploadForm.post('/api/upload-statement');
        }
    }

    // import { useNotifications } from "@/composables/useNotifications";

    // Notification system
    // const { showSuccess, showError, formatValidationErrors } = useNotifications();

    const authStore = useAuthStore();

    // const router = useRouter();

    // User state
    const currentUser = ref({});
    const isRefreshing = ref(false);

    if (authStore.isAuthenticated) {
        currentUser.value = authStore.user;
    }

    // Date
    const currentDate = computed(() => {
        return new Date().toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    });

    // Role-based messages
    // const getRoleMessage = computed(() => {
    //   return currentUser.value?.role === "Supervisor"
    //     ? "You have 0 tickets pending assignment"
    //   : "You have 0 tickets in progress";
    //});

    //const getRoleSubMessage = computed(() => {
    //    return currentUser.value?.role === "Supervisor"
    //        ? "0 officers currently working"
    //        : "Complete 0 more to reach daily goal";
    //});


    // Actions
    // const generateReport = () => {
    //   router.push("/reports");
    // };

    const getDashboardData = async () => {
        isRefreshing.value = true;
        try {
            // Dashboard data logic would go here
        } catch (error) {
            console.log(error);
        } finally {
            isRefreshing.value = false;
        }
    };

    // Initialize
    onMounted(() => {
        getDashboardData();
    });
</script>